module.exports = __webpack_public_path__ + "img/2.f5e250a2.png";